/** FO 1.2 — Ploko Q1 (NL copy, merge fields: voornaam, company, email). Unsubscribe voegt worker toe. */
export const PLOKO_Q1_CAMPAIGNS = [
    {
        campaignName: 'Ploko | nurture | inbound-30d',
        listName: 'Ploko | lijst | inbound',
        sequenceName: 'Ploko | sequence | nurture inbound 3-step',
        type: 'partnership',
        templateCategory: 'nurture_inbound',
        steps: [
            {
                step_order: 0,
                wait_days: 0,
                subject_template: 'Bedankt voor je bericht — Ploko',
                body_text_template: `Hoi {{voornaam}},

Bedankt voor je aanvraag via ploko.nl — we hebben je bericht ontvangen.

Binnen één werkdag kijken we mee wat het beste past bij {{company}} (website, vindbaarheid of groei online).

Heb je nu al een concrete vraag? Reply gerust op deze mail.

Groet,
Ploko`,
            },
            {
                step_order: 1,
                wait_days: 2,
                subject_template: 'Korte follow-up — ploko.nl',
                body_text_template: `Hoi {{voornaam}},

Even checken of je nog ergens mee zit.

Veel ondernemers in {{company}}-achtige situaties beginnen met:
- een heldere site die converteert
- basis SEO / Google-zichtbaarheid
- vaste content of campagnes

Wil je een kort belmoment (15 min) of liever eerst per mail?

Groet,
Ploko`,
            },
            {
                step_order: 2,
                wait_days: 5,
                subject_template: 'Nog relevant voor {{company}}?',
                body_text_template: `Hoi {{voornaam}},

Laatste berichtje van mijn kant — als timing niet goed is, geen probleem.

Zo ja: wat is je belangrijkste doel online de komende maanden? Dan reageer ik gericht.

Groet,
Ploko`,
            },
        ],
    },
    {
        campaignName: 'Ploko | cold | lokale-mkb-v1',
        listName: 'Ploko | lijst | lokale MKB v1',
        sequenceName: 'Ploko | sequence | cold MKB 3-step',
        type: 'cold_outreach',
        templateCategory: 'cold_mkb',
        steps: [
            {
                step_order: 0,
                wait_days: 0,
                subject_template: 'Vraag over online vindbaarheid — {{company}}',
                body_text_template: `Hoi {{voornaam}},

Ik zag {{company}} en vroeg me af: merken jullie dat aanvragen of contact via de site soms achterblijven?

Wij helpen lokale MKB-bedrijven met websites die wél leads opleveren (Ploko, ploko.nl).

Is dit iets waar jullie deze maand naar kijken? Zo nee, laat het gerust weten.

Groet,
Ploko`,
            },
            {
                step_order: 1,
                wait_days: 4,
                subject_template: 'Re: {{company}} — kort voorbeeld',
                body_text_template: `Hoi {{voornaam}},

Kort follow-up — we zien vaak dat kleine aanpassingen (snelheid, duidelijke CTA, lokale SEO) snel verschil maken.

Heb je 10 minuten voor een voorbeeld op jullie situatie?

Groet,
Ploko`,
            },
            {
                step_order: 2,
                wait_days: 7,
                subject_template: 'Afsluiten — nog interesse?',
                body_text_template: `Hoi {{voornaam}},

Ik sluit de reeks af — als dit niet relevant is, hoef je niets te doen (of gebruik de afmeldlink).

Mocht je later willen sparren over jullie online groei, reply is genoeg.

Groet,
Ploko`,
            },
        ],
    },
    {
        campaignName: 'Ploko | backlink | guest-post-v1',
        listName: 'Ploko | lijst | guest post v1',
        sequenceName: 'Ploko | sequence | guest post 3-step',
        type: 'backlink',
        templateCategory: 'backlink_guest',
        steps: [
            {
                step_order: 0,
                wait_days: 0,
                subject_template: 'Gastartikel idee voor jullie site',
                body_text_template: `Hoi {{voornaam}},

Ik las jullie content en dacht: een praktisch stuk over lokale online vindbaarheid / websites voor MKB past goed bij jullie publiek.

Ik schrijf voor Ploko (ploko.nl) en kan een uniek artikel aanleveren — geen copy-paste template.

Interesse in een kort idee-outline?

Groet,
Ploko`,
            },
            {
                step_order: 1,
                wait_days: 7,
                subject_template: 'Alternatief: link of samenwerking',
                body_text_template: `Hoi {{voornaam}},

Als gastblog geen fit is: hebben jullie een resources-pagina waar een relevante Ploko-link past? Ik denk graag mee.

Groet,
Ploko`,
            },
            {
                step_order: 2,
                wait_days: 14,
                subject_template: 'Laatste ping — guest post',
                body_text_template: `Hoi {{voornaam}},

Korte follow-up en dan laat ik het rusten. Laat weten of ik een outline mag sturen.

Groet,
Ploko`,
            },
        ],
    },
];
/** Pirova nurture (B-02 / B-08) — zelfde structuur, andere copy. */
export const PIROVA_Q1_NURTURE = {
    campaignName: 'Pirova | nurture | inbound-30d',
    listName: 'Pirova | lijst | inbound',
    sequenceName: 'Pirova | sequence | nurture inbound 3-step',
    type: 'partnership',
    templateCategory: 'nurture_inbound',
    steps: PLOKO_Q1_CAMPAIGNS[0].steps.map((s) => ({
        ...s,
        body_text_template: s.body_text_template.replace(/Ploko/g, 'Pirova').replace(/ploko\.nl/g, 'pirova.nl'),
        subject_template: s.subject_template.replace(/ploko\.nl/g, 'pirova.nl'),
    })),
};
//# sourceMappingURL=q1CampaignCatalog.js.map